import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const ReturnOrder = apiContainer.ReturnOrder
//GET--->
// Corrected getReturnOrder function
export async function getReturnOrderApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${ReturnOrder}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//CREATE---->
export async function createReturnOrder(request) {
    try {
        return api.create(`${ReturnOrder}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateReturnOrder(request, ReturnOrderId) {
    try {
        return api.update(`${ReturnOrder}/${ReturnOrderId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteReturnOrder(ReturnOrderId) {
    try {
        return api.delete(`${ReturnOrder}/${ReturnOrderId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}



